// Convert chart data to relative for % based comparison
(() => {
  const chartContainerId = 'wpDataChart_6'; // <-- change

  function getChartByContainerId(id) {
    if (!window.Highcharts || !Array.isArray(Highcharts.charts)) return null;
    return Highcharts.charts.find(c => c && c.renderTo && c.renderTo.id === id) || null;
  }

  function applyRelativeMode(chart) {
    chart.update({
      plotOptions: {
        series: {
          compare: 'percent',
          compareBase: 0
        }
      },
      // If you want the axis to be % labels, uncomment:
      // yAxis: { labels: { format: '{value}%' } },

      tooltip: {
        pointFormatter: function () {
          // When compare is enabled, Highcharts sets point.change
          const ch = (typeof this.change === 'number') ? this.change : null;
          const chText = (ch !== null) ? (ch.toFixed(2) + '%') : '—';
          return `<span style="color:${this.color}">●</span> ${this.series.name}: <b>${chText}</b><br/>`;
        }
      }
    }, true);
  }

  function init() {
    const chart = getChartByContainerId(chartContainerId);
    if (!chart) return setTimeout(init, 250);
    applyRelativeMode(chart);
  }

  document.addEventListener('DOMContentLoaded', init);
})();

// Link the table and chart for universes
  (() => {
    // ===== CONFIG =====
    const tableSelector = '#table_1';     // your wpDataTable <table> selector
    const chartContainerId = 'wpDataChart_6';   // the div id Highcharts renders into
    const keyColIndex = 0;                     // td index containing the series key (ticker/id/name)
  
    // ===== HELPERS =====
    function getChart(containerId) {
      if (!window.Highcharts || !Array.isArray(Highcharts.charts)) return null;
      return Highcharts.charts.find(c => c && c.renderTo && c.renderTo.id === containerId) || null;
    }
  
    function findSeries(chart, key) {
      // Prefer id lookup (chart.get), fallback to matching by series.name
      return (chart.get && chart.get(key)) || chart.series.find(s => s.name === key) || null;
    }
  
    function closest(el, selector) {
      while (el && el.nodeType === 1) {
        if (el.matches(selector)) return el;
        el = el.parentElement;
      }
      return null;
    }
  
    function setSeriesShown(series, shouldShow) {
      // 1) show/hide the line
      series.setVisible(shouldShow, false);
  
      // 2) show/hide it in legend completely
      //    (update can be heavier, so we redraw once after all changes)
      series.update({ showInLegend: shouldShow }, false);
    }
  
    function hideAllSeriesAndLegend(chart) {
      chart.series.forEach(s => {
        // Hide from plot + legend
        s.setVisible(false, false);
        s.update({ showInLegend: false }, false);
      });
      chart.redraw();
    }
  
    // ===== INIT =====
    function init() {
      const table = document.querySelector(tableSelector);
      if (!table) return;
  
      const chart = getChart(chartContainerId);
      if (!chart) {
        setTimeout(init, 250); // chart may initialize async
        return;
      }
  
      // Default: everything hidden, including legend entries
      hideAllSeriesAndLegend(chart);
  
      // Delegated click handler (works even after DataTables redraws)
      table.addEventListener('click', (e) => {
        const tr = closest(e.target, 'tbody tr');
        if (!tr) return;
  
        const tds = tr.querySelectorAll('td');
        const key = (tds[keyColIndex]?.textContent || '').trim();
        if (!key) return;
  
        const series = findSeries(chart, key);
        if (!series) {
          console.warn('No matching series found for key:', key);
          return;
        }
  
        const shouldShow = !series.visible;
  
        // Toggle row class
        tr.classList.toggle('active', shouldShow);
  
        // Toggle series + legend entry
        setSeriesShown(series, shouldShow);
  
        chart.redraw();
      });
    }
  
    document.addEventListener('DOMContentLoaded', init);
  })();




// Modal Popup for leaving site
document.addEventListener("DOMContentLoaded", function () {
  const menuLink = document.querySelector("#menu-item-513 a")
  if (!menuLink) return

  menuLink.addEventListener("click", function (e) {
    e.preventDefault()
    const targetUrl = menuLink.href

    // --- Create modal overlay ---
    const modal = document.createElement("div")
    modal.id = "exit-modal"

    // --- Modal content box ---
    const box = document.createElement("div")
    box.id = "exit-modal-box"
    box.innerHTML = `
            <h3 class="exit-modal-title">Notice</h3>
            <p>
            You are now leaving the sub-advisor area and entering the ETF area.
            The following link contains information concerning investments, products 
            or other information that is distributed by PINE Distributors, LLC. 
            This information is not an offer to buy or a solicitation to sell any 
            security or investment product. Such an offer or solicitation is made 
            only by the securities’ or investment products’ issuer or sponsor 
            through a prospectus or other offering documentation. Investments 
            involve risk. Principal loss is possible.
            </p>
            
            <div class="exit-modal-buttons">
                <button class="exit-modal-button return" id="exit-return-btn">
                    Return
                </button>

                <button class="exit-modal-button continue" id="exit-continue-btn">
                    Continue
                </button>
            </div>
        `

    modal.appendChild(box)
    document.body.appendChild(modal)

    // Hide scrollbar when modal opens
    document.body.style.overflow = "hidden"

    // --- Continue to page ---
    document
      .getElementById("exit-continue-btn")
      .addEventListener("click", function () {
        document.body.style.overflow = "" // restore scroll
        window.location.href = targetUrl
      })

    // --- Return (close modal) ---
    document
      .getElementById("exit-return-btn")
      .addEventListener("click", function () {
        document.body.style.overflow = "" // restore scroll
        modal.remove()
      })

    // --- Close modal when clicking outside box ---
    modal.addEventListener("click", function (event) {
      if (event.target === modal) {
        document.body.style.overflow = "" // restore scroll
        modal.remove()
      }
    })
  })
})

// Newsletter Popup
const newsletterPopup = document.getElementById("newsletter-popup")
const showPopupBtn = document.getElementById("show-newsletter-popup")
const closePopupSelectors = [
  "#newsletter-popup .bg",
  "#newsletter-popup .close",
]
showPopupBtn.addEventListener("click", () => {
  newsletterPopup.classList.add("open")
  document.body.classList.add("no-scroll")
})
closePopupSelectors.forEach((selector) => {
  const el = document.querySelector(selector)
  if (el) {
    el.addEventListener("click", () => {
      newsletterPopup.classList.remove("open")
      document.body.classList.remove("no-scroll")
    })
  }
})

// Subscription Level Selector
document.addEventListener("DOMContentLoaded", function () {
  const columns = document.querySelectorAll(".tiers-table td, .tiers-table th")
  const subscriptionLevels = {
    1: document.querySelector(".rcp_subscription_level_3 input"),
    2: document.querySelector(".rcp_subscription_level_2 input"),
    3: document.querySelector(".rcp_subscription_level_1 input"),
  }

  // Mouse enter and leave events for columns
  columns.forEach((cell) => {
    cell.addEventListener("mouseenter", function () {
      let index = this.cellIndex
      document
        .querySelectorAll(
          `.tiers-table td:nth-child(${index + 1}), .tiers-table th:nth-child(${
            index + 1
          })`
        )
        .forEach((el) => el.classList.add("hovered-column"))
    })

    cell.addEventListener("mouseleave", function () {
      let index = this.cellIndex
      document
        .querySelectorAll(
          `.tiers-table td:nth-child(${index + 1}), .tiers-table th:nth-child(${
            index + 1
          })`
        )
        .forEach((el) => el.classList.remove("hovered-column"))
    })

    cell.addEventListener("click", function () {
      let index = this.cellIndex // Zero-based index

      // Remove previous selections
      document
        .querySelectorAll(".tiers-table .selected-column")
        .forEach((el) => {
          el.classList.remove("selected-column")
        })

      // Add selection class to the clicked column (both td and th)
      document
        .querySelectorAll(
          `.tiers-table td:nth-child(${index + 1}), .tiers-table th:nth-child(${
            index + 1
          })`
        )
        .forEach((el) => el.classList.add("selected-column"))

      // Remove 'active' class from all tiers
      document.querySelectorAll(".tier-info .tier").forEach((el) => {
        el.classList.remove("active")
      })

      // Adjusted tier selection (Column 2 = Tier 1)
      let tierIndex = index // Shift by 1
      let tierClass = `.tier-info .tier${tierIndex}`
      let selectedTier = document.querySelector(tierClass)
      if (selectedTier) {
        selectedTier.classList.add("active")
      } else {
        document.querySelector(".tier-info .tier3").classList.add("active")
      }

      // Simulate a click on the corresponding subscription level
      switch (index) {
        case 1:
          console.log("Simulating click on Tier 3")
          subscriptionLevels[1] && subscriptionLevels[1].click()
          break
        case 2:
          console.log("Simulating click on Tier 2")
          subscriptionLevels[2] && subscriptionLevels[2].click()
          break
        case 3:
          console.log("Simulating click on Tier 1")
          subscriptionLevels[3] && subscriptionLevels[3].click()
          break
        default:
          break
      }
    })
  })

  // Trigger the corresponding column click when subscription level is clicked
  Object.keys(subscriptionLevels).forEach((tier) => {
    if (subscriptionLevels[tier]) {
      subscriptionLevels[tier].addEventListener("click", function () {
        console.log(`Subscription level ${tier} clicked`)
        // Trigger a click on the corresponding table column
        let index = parseInt(tier) // Convert the tier number to a column index
        let column = document.querySelector(
          `.tiers-table th:nth-child(${index + 1}), .tiers-table td:nth-child(${
            index + 1
          })`
        )
        if (column) {
          column.click()
        }
      })
    }
  })
})

jQuery(document).ready(function () {
  jQuery(".slick-features1").slick({
    nextArrow: ".slider-section1 .next",
    prevArrow: ".slider-section1 .prev",
    speed: 800,
    pauseOnHover: false,
    autoplay: false,
    autoplaySpeed: 9000,
    fade: true,
    dots: true,
    dotsClass: "slick-pager1",
    infinite: false,
    adaptiveHeight: true,
  })
  jQuery(".slick-features2").slick({
    nextArrow: ".slider-section2 .next",
    prevArrow: ".slider-section2 .prev",
    speed: 800,
    pauseOnHover: false,
    autoplay: false,
    autoplaySpeed: 9000,
    fade: true,
    dots: true,
    dotsClass: "slick-pager2",
    infinite: false,
    adaptiveHeight: true,
  })
})

// Remove /?new_registration from the url and remove "new-registration" from the body class list
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".alert1 .close").forEach((button) => {
    button.addEventListener("click", function () {
      // Remove "new-registration" class from the body
      document.body.classList.remove("new-registration")

      // Remove "?new_registration" from the URL without reloading
      const url = new URL(window.location.href)
      url.searchParams.delete("new_registration")
      window.history.replaceState({}, document.title, url.pathname + url.search)
    })
  })
})

// hide alert2 on close btn click
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".alert2 .close").forEach((button) => {
    button.addEventListener("click", function () {
      this.closest(".alert2").classList.add("hide")
    })
  })
})

//Scroll to section on mouse click
const mouseBtn = document.getElementById("mouseBtn")
if (mouseBtn) {
  mouseBtn.addEventListener("click", function () {
    const section = document.getElementById("section1")
    const offset = 113 // Padding above

    if (section) {
      const top = section.getBoundingClientRect().top + window.scrollY - offset
      window.scrollTo({ top, behavior: "smooth" })
    }
  })
}

// Wow Animations
wowAnimations({
  offset: -50,
  mobile: true,
  fastMobileAnim: true,
  mobileBreakpoint: 48,
  fastMobileDuration: ".9s",
})

// Parallax Effects
pureParallax({
  selector: "[data-depth]",
  axisSelector: "parallax-x",
  bgSelector: "parallax-bg",
  topSelector: "parallax-top",
  btmSelector: "parallax-btm",
  offsetHeader: true,
  headerId: "hd",
  minWidth: 64,
  outerSection: "section-container",
})

// Responsive Nav
vanillaNav({
  breakpointMax: 64, // Breakpoint Width in EMs
})

// Sticky Elems
// var sticky = new Sticky("[data-sticky]", {})

//activeElements
// activeElements({
//   selector: ".activeView",
//   activeClass: "active",
// })

// Wrap Letter In Span
// wrapLettersInSpan({
//   selector: "h1 .top, h1 .btm",
//   letterClass: "",
//   preserveSpaces: false,
//   includeLineBreaks: false,
// })

// Add home ready class
window.addEventListener(
  "scroll",
  function () {
    const body = document.querySelector("body.home")
    if (body) {
      if (window.scrollY > 100) {
        body.classList.remove("ready")
      } else {
        body.classList.add("ready")
      }
    }
  },
  { passive: true }
)

/*
	
	counterUp({
		selector: '.counter',
		activeClass: 'countStart',
		completeClass: 'countComplete',
		offset: 0
  });
  
	*/

// Back to top animate
document.querySelector(".back-to-top").addEventListener("click", function (e) {
  e.preventDefault()
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  })
})

// Email protection
// jQuery("a.email").emailProt()

// Open external links in new windows
const domainName = window.location.hostname

// Select external links and modify them
document
  .querySelectorAll('a[href^="http://"], a[href^="https://"]')
  .forEach((link) => {
    // Check if link is NOT to the current domain
    if (!link.href.includes(domainName)) {
      link.classList.add("external")
      link.setAttribute("target", "_blank")
      link.setAttribute("rel", "noopener noreferrer")
    }
  })

// Smooth scroll function
function smoothScrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  })
  return false
}
